export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = vendor